module.exports = __webpack_public_path__ + "static/media/enlarger_right.8ea85c9d.jpg";